import { Box, MultiSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="normal" />
			<Text semiBold text="overflow" />
			<MultiSelect
				options={items}
				value={[items[0]]}
			/>
			<Box ml={30} width={200}>
				<MultiSelect
					options={items}
					value={[items[4]]}
				/>
			</Box>
		</CssColumnGrid>
	);
};